/**
 * Realiza uma comparação profunda entre dois valores
 * Suporta objetos, arrays, valores primitivos e valores especiais como Date, null, undefined
 *
 * @param a - Primeiro valor para comparação
 * @param b - Segundo valor para comparação
 * @returns true se os valores forem profundamente iguais, false caso contrário
 */
export function deepEqual(a: any, b: any): boolean {
  // Verificação de referência - se são exatamente o mesmo objeto
  if (a === b) {
    return true
  }

  // Verificação de null e undefined
  if (a == null || b == null) {
    return a === b
  }

  // Verificação de tipos diferentes
  if (typeof a !== typeof b) {
    return false
  }

  // Verificação para tipos primitivos (string, number, boolean)
  if (typeof a !== 'object') {
    return a === b
  }

  // Verificação especial para Date
  if (a instanceof Date && b instanceof Date) {
    return a.getTime() === b.getTime()
  }

  // Verificação especial para RegExp
  if (a instanceof RegExp && b instanceof RegExp) {
    return a.toString() === b.toString()
  }

  // Se apenas um é array, não são iguais
  if (Array.isArray(a) !== Array.isArray(b)) {
    return false
  }

  // Comparação de arrays
  if (Array.isArray(a)) {
    if (a.length !== b.length) {
      return false
    }
    for (let i = 0; i < a.length; i++) {
      if (!deepEqual(a[i], b[i])) {
        return false
      }
    }
    return true
  }

  // Comparação de objetos
  const keysA = Object.keys(a)
  const keysB = Object.keys(b)

  // Se têm número diferente de propriedades
  if (keysA.length !== keysB.length) {
    return false
  }

  // Verificar se todas as chaves de A existem em B e têm valores iguais
  for (const key of keysA) {
    if (!keysB.includes(key)) {
      return false
    }
    if (!deepEqual(a[key], b[key])) {
      return false
    }
  }

  return true
}

/**
 * Alias para deepEqual para compatibilidade
 */
export const isDeepEqual = deepEqual
